module.exports = __webpack_public_path__ + "static/media/Triangle Prism.c1466f1e.kra";